import React from 'react';
import { FAQ } from '../../components/FAQ/FAQ';
export function FAQSection() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="text-center mb-12" data-id="element-85">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight" data-id="element-86">
            Residential Glass Questions
          </h2>
        </div>
        <FAQ data-id="element-87" />
      </div>
    </section>;
}